module.exports = __webpack_public_path__ + "static/media/app-image-3.e8da9199.png";